/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/pt';

import FixedContainer from '../../components/Container';
import { Box, Modal, Typography } from '@mui/material';
import LoadingComponent from '../../components/LoadingComponent';
import CustomizedTables from '../../components/Table';
import EditIcon from '@mui/icons-material/Edit';
import EditModal from './components/editModal';
import { enqueueSnackbar } from 'notistack';
import { GetFetch, urls } from '../../services/apiBase';
import { ColumnsRates } from "./utils";
import { useLocation } from 'react-router-dom';

const BoiGordoDatAgro = () => {
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [tradeAgreementToEdit, setTradeAgreementToEdit] = useState({});
  const [tableValues, setTableValues] = useState([]);

  const table = location.state.table;

  const handleOpenEditModal = (indicator) => {
    setTradeAgreementToEdit(indicator);
    setOpenEditModal(true);
  }

  const handleClose = () => {
    setOpenEditModal(false);
  }

  const fillTable = async () => {
    setLoading(true);
    try {
      const response = await GetFetch(urls.GET_BOI_GORDO);

      if (!response.data || response.data.length === 0) {
        enqueueSnackbar("Não existem indicadores", { variant: "error" });
        return;
      }
      setTableValues(response.data);
      setError(false);
    } catch (error) {
      console.log(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  const registerButtonComponent = (row) => {
    return (
      tableValues[0] === row && <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '50%',
          cursor: 'pointer'
        }}
        onClick={() => handleOpenEditModal(row)}
      >
        <EditIcon />
      </Box>
    )
  }

  const TableComponent = () => {
    return (
      <Box>
        {tableValues && tableValues.length > 0 ? (
          <>
            <CustomizedTables
              data={tableValues}
              columns={ColumnsRates}
              moreOptionsTitle={"Editar"}
              moreOptions={registerButtonComponent}
            />
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              margin: 3,
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}
            >
              Não foram encontradas indicadores
            </Typography>
          </Box>
        )}
      </Box>
    );
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar os indicadores
        </Typography>
      </Box>
    )
  }

  useEffect(() => {
    fillTable();
  }, []);

  moment.locale('pt');
  return (
    <>
      <FixedContainer>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "#F9FBFD",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            boxShadow: 3,
            borderRadius: "10px",
            padding: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 1 }}
          >
            Indicadores Financeiros / Boi Gordo
          </Typography>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              alignItems: "center",
              marginBottom: 1,
              marginTop: 1,
            }}
          ></Box>
          {loading ? (
            <LoadingComponent />
          ) : error ? (
            errorMessage()
          ) : tableValues && tableValues.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 2 }}
              >
                No momento não existem indicadores
              </Typography>
            </Box>
          ) : (
            <>
              <TableComponent />
            </>
          )}
        </Box>
      </FixedContainer>

      <Modal
        open={openEditModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <EditModal
          onClose={handleClose}
          agreement={tradeAgreementToEdit}
          getList={fillTable}
          table={table}
        />
      </Modal>
    </>
  );
}

export default BoiGordoDatAgro;